module.exports = __webpack_public_path__ + "static/media/cow-in-cycle.684e71d3.png";